<template>
	<common-welcomebox
		card-type="dismiss"
		:title="greeting"
		:hide-button="true"
		subtitle=" "
		:video-src="videoSrc"
		@dismiss="dismiss({ key: upsellKey })"
	>
		<slot></slot>
		<core-upgrade-button
			:arrow="true"
			size="monster"
			color="green"
			target="_blank"
			:utm-medium="utmMedium"
			style="text-transform: uppercase"
		>
			Unlock {{ planName }} Now!
		</core-upgrade-button>
	</common-welcomebox>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	props: {
		videoSrc: {
			type: String,
			default: '',
		},
		upsellKey: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapGetters(['userFirstName', 'proUpsellPlan']),
		greeting() {
			let name = '';
			if (this.userFirstName) {
				name += ', ' + this.userFirstName;
			}

			return `Ready for more power${name}?`;
		},
		utmMedium() {
			return `Dashboard${this.upsellKey}Box`;
		},
		planName() {
			return this.proUpsellPlan;
		},
	},
	methods: {
		...mapMutations('dashboard', ['dismiss']),
	},
};
</script>
